<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-cogs</v-icon>
            <span class="px-3">{{ $t('View Outlet Information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-3>
              <strong>{{ $t('Outlet') }}</strong>
            </v-flex>

            <v-flex xs12 sm4 mb-2>
              <v-layout column style="margin:0 auto; max-width:calc(100% - 20px);">
                <v-flex xs12>
                  <a v-if="outletInfo.attachment" @click="dialogs.imageViewerDialog = true">
                    <v-img :src="`${baseUrls.images}/${outletInfo.attachment}`" height="250" />
                  </a>
                  <v-img class="not-printable" v-else :src="`${baseUrls.images}/no-image-available.png`" height="250" />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm8 :class="{ 'pt-2': $vuetify.breakpoint.xsOnly, 'px-2': true }">
              <v-layout row wrap>
                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Name') }}</div>
                  <strong>{{ outletInfo.outlet_name || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Phone') }}</div>
                  <strong>{{ outletInfo.outlet_phone || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Email') }}</div>
                  <strong>{{ outletInfo.outlet_email || '-' }}</strong>
                </v-flex>
                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">{{ $t('Website') }}</div>
                  <strong>{{ outletInfo.outlet_website || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Company Name (en)') }}
                  </div>
                  <strong>{{ outletInfo.company_name_en || '-' }}</strong>
                </v-flex>
                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Company Name (ar)') }}
                  </div>
                  <strong>{{ outletInfo.company_name_ar || '-' }}</strong>
                </v-flex>

                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Outlet Slogan (en)') }}
                  </div>
                  <strong>{{ outletInfo.outlet_slogan_en || '-' }}</strong>
                </v-flex>
                <v-flex xs6 class="pb-3">
                  <div class="caption no-select">
                    {{ $t('Outlet Slogan (ar)') }}
                  </div>
                  <strong>{{ outletInfo.outlet_slogan_ar || '-' }}</strong>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 py-3 pl-2>
                <div class="caption no-select">{{ $t('User Per Outlet') }}</div>
                <strong>{{ outletInfo.user_per_outlet }}</strong>
              </v-flex>
              <v-flex xs12 py-3 pl-2>
                <div class="caption no-select">{{ $t('Address') }}</div>
                <strong v-html="lnToBr(outletInfo.outlet_address) || '-'" />
              </v-flex>
            </v-layout>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>

    <image-viewer
      :imageSrc="outletInfo.attachment"
      :maxWidth="700"
      :imageViewerDialog="dialogs.imageViewerDialog"
      @hidemodal="dialogs.imageViewerDialog = false"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    imageViewer: () => import('@/views/_partials/AppImageViewer.vue'),
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      dialogs: {
        imageViewerDialog: false
      }
    }
  },

  computed: {
    ...mapGetters({
      outletInfo: 'outlets/getOutletInfo',
      baseUrls: 'misc/getBaseUrls'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
